import { useEffect, useState } from "react";
import api from "../lib/api";

export default function News() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/news").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="grain min-h-screen max-w-5xl mx-auto px-6 sm:px-10 pt-20 pb-24" data-testid="news-page">
      <div className="label-eyebrow">Movement Updates</div>
      <h1 className="mt-4 font-serif text-5xl sm:text-6xl text-bdu-cream tracking-tight">News from the Fund</h1>
      <div className="mt-10 divider-gold" />

      {loading ? (
        <div className="text-bdu-cream/50 py-16 text-center">Loading updates...</div>
      ) : items.length === 0 ? (
        <div className="mt-16 bdu-card text-center py-14" data-testid="news-empty">
          <div className="font-serif text-2xl text-bdu-cream">No updates yet.</div>
          <p className="mt-3 text-bdu-cream/60">Check back soon — the fund launches with the community.</p>
        </div>
      ) : (
        <div className="mt-14 space-y-14">
          {items.map((n) => (
            <article key={n.id} className="border-b border-bdu-gold/10 pb-14 last:border-0" data-testid={`news-item-${n.id}`}>
              <div className="label-eyebrow" style={{ fontSize: "0.6rem" }}>
                {new Date(n.created_at).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" })} · {n.author}
              </div>
              <h2 className="mt-4 font-serif text-3xl sm:text-4xl text-bdu-cream tracking-tight">{n.title}</h2>
              {n.image_url && (
                <img src={n.image_url} alt="" className="mt-6 w-full h-64 object-cover border border-bdu-gold/10" />
              )}
              <p className="mt-6 text-bdu-cream/75 leading-loose whitespace-pre-wrap">{n.body}</p>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
